import React from 'react';
import SupportTicketLink from 'common/components/SupportTicketLink';
import { Trans, withTranslation } from 'react-i18next';

const DefaultNoContentMessage = ({ isPwcUser, t }) => {
  const getPwcUserMessage = () => {
    return (
      <Trans i18nKey="pleaseTryAgainCreateTicket">
        Please try again later. If the issue continues, please
        <SupportTicketLink /> for this issue.
      </Trans>
    );
  };

  const getClientMessage = () => {
    return <>{t('contactEngagementLead')}</>;
  };

  return (
    <div
      data-testid="unable-to-load-data-default-message"
      className="content-section"
    >
      {isPwcUser && getPwcUserMessage()}
      {!isPwcUser && getClientMessage()}
    </div>
  );
};

export default withTranslation()(DefaultNoContentMessage);
